import { render, staticRenderFns } from "./ShowProfileUrl.vue?vue&type=template&id=c1d10e2a"
import script from "./ShowProfileUrl.vue?vue&type=script&lang=js"
export * from "./ShowProfileUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports